import React, { FC, useState } from 'react';
import { Modal, InputNumber, Button } from 'antd';

import { useTranslate } from '@/translations';
import { useUpdateInspectionMileage } from '@/api/Inspections';
import { faEdit, Icon } from '@/ui/components';
import { Inspection } from '@/types';

interface InspectionUpdateMileageProps {
  inspection: Inspection;
  canEdit?: boolean;
}
export const InspectionUpdateMileage: FC<InspectionUpdateMileageProps> = ({
  inspection,
  canEdit = false,
}) => {
  const { t } = useTranslate();
  const { mutateAsync: updateInspectionMileage } = useUpdateInspectionMileage();
  const [mileage, setMileage] = useState(inspection.mileage);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUpdateInspectionMileage = async () => {
    try {
      await updateInspectionMileage({ id: inspection.id, mileage });
      setIsModalOpen(false);
    } catch (error) {
      console.log('handleUpdateInspectionMileage: ', { error });
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span>
        {mileage} {t('miles')}
      </span>
      {canEdit ? (
        <Icon icon={faEdit} onClick={() => setIsModalOpen(true)} />
      ) : null}
      <Modal
        title={t('updateMileage')}
        open={isModalOpen}
        onOk={handleUpdateInspectionMileage}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={handleUpdateInspectionMileage}
          >
            Save
          </Button>,
          <Button key="back" onClick={() => setIsModalOpen(false)}>
            Return
          </Button>,
        ]}
      >
        <InputNumber
          min={0}
          value={mileage}
          onChange={(value) => setMileage(value || 0)}
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  );
};
